import { APP } from 'src/app/config/app';
import { IScheduleViewOptions } from 'src/app/models';
import { ScheduleViewOption } from 'src/app/models/enums';

export function normalizeViewOptions(stored: unknown): IScheduleViewOptions {
  const values = stored && typeof stored === 'object' ? (stored as Record<string, unknown>) : {};
  return Object.values(ScheduleViewOption).reduce(
    (options, option) => (typeof values[option] === 'boolean' ? { ...options, [option]: values[option] } : options),
    { ...APP.SCHEDULE_DEFAULT_VIEW_OPTIONS },
  );
}
